import Image from "next/legacy/image"

export const CancelIcon = () => {
  return (
    <Image
      src="/assets/icons/clear-search.svg"
      alt="clear"
      aria-label="clear"
      layout="fixed"
      width={10}
      height={10}
    />
  )
}
